// extracted by mini-css-extract-plugin
export default {"wrapper":"inforow_wrapper--tuqlB","label":"inforow_label--O7Byv","value":"inforow_value--q1VRh"};